"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _AffiliateLayout = _interopRequireDefault(require("./AffiliateLayout"));
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var route = ownProps.route;
  return {
    route: route,
    siteName: _config["default"].global.siteName
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_AffiliateLayout["default"]);